import React, { useState } from 'react';
import moment from 'moment/moment';
import PropertiesPageHeader from 'components/dashboard/Properties/PropertiesPageHeader';
import {
  PaymentCalendarSection,
  TasksCalendarSection,
  TodayCalendarSection,
  TodayTablesSection,
  VacancyCalendarSection,
} from '@/components/dashboard/Calendar';
import { useNavigate } from 'react-router-dom';
import './CalendarPage.scss';
import UIButton from '@/components/shared/UIButton';
import UIPageTitle from '@/components/shared/UIPageTitle';

const BackToDashboardButton = () => {
  const navigate = useNavigate();
  return (
    <UIButton
      outline={true}
      variant="primary"
      size="medium"
      onClick={() => navigate('/dashboard')}
    >
      Back to Dashboard
    </UIButton>
  );
};

moment.locale('en');

const baseClass = 'CalendarPage';

const CalendarPage = () => {
  const navigate = useNavigate();
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [isCalendarCollapsed, setIsCalendarCollapsed] = useState(false);
  const [isPaymentCalendarCollapsed, setIsPaymentCalendarCollapsed] =
    useState(false);
  const [isVacancyCalendarCollapsed, setIsVacancyCalendarCollapsed] =
    useState(false);
  const [isTasksCalendarCollapsed, setIsTasksCalendarCollapsed] =
    useState(false);

  const handleBackToDashboard = () => {
    navigate('/dashboard');
  };

  const handleDateChange = (date: Date) => {
    setSelectedDate(date);
  };

  const handleToggleCollapse = () => {
    setIsCalendarCollapsed(!isCalendarCollapsed);
  };

  // Handlers for table actions
  const handleViewAllPayments = () => {
    console.log('Navigate to payments page');
    // navigate('/payments');
  };

  const handleViewAllVacancies = () => {
    console.log('Navigate to vacancies page');
    // navigate('/vacancies');
  };

  const handleViewAllTasks = () => {
    console.log('Navigate to tasks page');
    // navigate('/tasks');
  };

  const handleTogglePaymentCalendarCollapse = () => {
    setIsPaymentCalendarCollapsed(!isPaymentCalendarCollapsed);
  };

  const handlePaymentRowAction = (id: string, action: string) => {
    console.log('Payment row action:', id, action);
    // Handle row actions like edit, delete, etc.
  };

  const handleToggleVacancyCalendarCollapse = () => {
    setIsVacancyCalendarCollapsed(!isVacancyCalendarCollapsed);
  };

  const handleVacancyRowAction = (id: string, action: string) => {
    console.log('Vacancy row action:', id, action);
    // Handle row actions like add user, edit, delete, etc.
  };

  const handleToggleTasksCalendarCollapse = () => {
    setIsTasksCalendarCollapsed(!isTasksCalendarCollapsed);
  };

  const handleTasksRowAction = (id: string, action: string) => {
    console.log('Tasks row action:', id, action);
    // Handle row actions like ticket, edit, delete, etc.
  };

  return (



    <>
    <UIPageTitle
      title="Daily Operation Dashboard"
      action={<BackToDashboardButton />}
    />

      <TodayCalendarSection
        selectedDate={selectedDate}
        onDateChange={handleDateChange}
        isCollapsed={isCalendarCollapsed}
        onToggleCollapse={handleToggleCollapse}
      />




        <TodayTablesSection
          onViewAllPayments={handleViewAllPayments}
          onViewAllVacancies={handleViewAllVacancies}
          onViewAllTasks={handleViewAllTasks}
        />

        <PaymentCalendarSection
          isCollapsed={isPaymentCalendarCollapsed}
          onToggleCollapse={handleTogglePaymentCalendarCollapse}
          onRowAction={handlePaymentRowAction}
        />

        <VacancyCalendarSection
          isCollapsed={isVacancyCalendarCollapsed}
          onToggleCollapse={handleToggleVacancyCalendarCollapse}
          onRowAction={handleVacancyRowAction}
        />

        <TasksCalendarSection
          id="tasks-calendar-section"
          isCollapsed={isTasksCalendarCollapsed}
          onToggleCollapse={handleToggleTasksCalendarCollapse}
          onRowAction={handleTasksRowAction}
        />


    </>
  );
};
export default CalendarPage;
